import script from "./GroupRoleBranchModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupRoleBranchModal.vue?vue&type=script&setup=true&lang=ts"

import "./GroupRoleBranchModal.vue?vue&type=style&index=0&id=5f00addd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f00addd"]])

export default __exports__